export enum EFileUploadTypes {
  Response = "response",
  Remediation = "remediation",
  Task = "task",
}
